// URLs configurables via .env.local (voir .env.local.example)
// Local par défaut — basculer vers test/prod via les variables REACT_APP_*
const SERVER_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3001/api/";
export const IMAGE_URL =
  process.env.REACT_APP_IMAGE_URL || "http://localhost:3001/";
const FRONT_END_SERVER_URL =
  process.env.REACT_APP_FRONT_URL || "http://localhost:3000/";





const ON_SERVER = process.env.REACT_APP_ON_SERVER;
export const BASE_URL = SERVER_URL;
export const DOWNLOAD_FILE_URL = `${IMAGE_URL}server/`;
export const URL_LINK = FRONT_END_SERVER_URL;

